import { useContext } from "react";

import { FileSettingsContext } from "~/contexts/file-settings-context";

export const useFileSettings = () => useContext(FileSettingsContext);
